import { FeedList } from "@/components/feed/FeedList";

export interface FeedPageProps {
  feedType?: string;
  title?: string;
}

export function FeedPage({ feedType, title }: FeedPageProps) {
  return (
    <div className="animate-in fade-in duration-500">
      <FeedList feedType={feedType} title={title} />
    </div>
  );
}
